export default "__VITE_ASSET__CH9DVCD4__"